import React, { useState } from "react";
import { ShieldUser } from "lucide-react";
import GrievanceDisputeContents from "./components/EmployeeReferralProgramPolicyContents";
import FullHeaderComponent from "../components/FullHeaderComponent";

const EmployeeReferralProgramPolicy = () => {
  const [searchTerm, setSearchTerm] = useState("");
  
  const handleSearch = (params) => {
      setSearchTerm(params?.keyword || "");
  };

  return (
    <div className="flex flex-col -mx-3 sm:-mx-4 md:-mx-6 -mt-3 sm:-mt-4 md:-mt-6">
      <FullHeaderComponent
        icon={ShieldUser}
        title="Employee Referral Program Policy"
        subtitle="Hyvid Philippines · Owner: Talent Acquisition"
        hyvidScope="Applies to: Eligible employees of Hyvid"
        searchHandler={handleSearch}
      />
        <div>
          <GrievanceDisputeContents searchTerm={searchTerm}/>
        </div>
    </div>
  );
};

export default EmployeeReferralProgramPolicy;